import { useMutation } from "react-query";
import { verifyAccountInvite } from "../api/account/verifyAccountInvite";

export const useMutationVerifyAccountInvite = () =>
  useMutation("account-invite", verifyAccountInvite, {});
